module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTguMzA5IiBoZWlnaHQ9IjExMy4wMDIiIHZpZXdCb3g9IjAgMCAxNTguMzA5IDExMy4wMDIiPgogIDxwYXRoIGQ9Ik0zMTYuMzEsMTk2SDE1OFY4NC40ODVBMTQyLjIxMywxNDIuMjEzLDAsMCwxLDE3OC41LDgzLDE0MC41MDgsMTQwLjUwOCwwLDAsMSwzMTYuMzEsMTk2WiIKICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU4IC04MykiIGZpbGw9IiMxNjI5NTciLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/footer/bck_roundindicator.svg
// module id = 929
// module chunks = 2